import { smoothScrollTop } from 'shared/lib/scrollTop';

export function scrollTopLink(link, location) {
  if (link === location) {
    smoothScrollTop();
  }
}
